<template>
    <div :class="{ 'mb80' : HasUnilevelBonusFromFrontliners() }">
        <h3 style="margin-bottom: 35px;">My Unilevel Bonus</h3>
        <div class="table-outer start-packet-table">
            <table class="table-style2">
                <thead>
                <tr class="start-packet-table">
                    <th v-for="(header, headerId) in GetTableHeader()"
                        :key="headerId"
                        :class="{ 'active': headerId === startPacket }">
                        <p v-html="header"
                           :class="{ 'small-header-font' : HasUnilevelBonusFromFrontliners() }"></p>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, rowId) in GetTableRows()"
                    :key="rowId">
                    <td v-for="(cell, cellId) in row"
                        :class="{ 'active': cellId === startPacket }"
                        :key="cellId">
                        <p>{{ cell }}</p>
                    </td>
                </tr>
                </tbody>
                <tr class="buy-items"
                    v-if="!HasUnilevelBonusFromFrontliners()">
                    <td v-for="(packet, packetId) in packets"
                        :key="packetId">
                        <a v-if="(packetId > parseInt(startPacket) && startPacket !== '25000') && packetId > 0"
                           class="buy-button disabled"
                           @click="!loader ? buyPacket(packetId) : ''">Buy</a>
                        <a class="buy-button button--progress"
                           v-if="packet.progress">buy</a>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>

    export default {
        dependencies: ['packet'],
        data () {
            return {
                tableData: {
                    0: {
                        tableHeaders: {
                            0:  'My start package',
                            100: 'FND 100',
                            250: 'FND 250',
                            500: 'FND 500',
                            1000: 'FND 1000',
                            5000: 'FND 5000',
                            10000: 'FND 10000',
                            25000: 'FND 25000',
                        },
                        tableRows: {
                            1: {
                                0: 'Level 1',
                                100: '1%',
                                250: '2%',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            2: {
                                0: 'Level 2',
                                100: '1%',
                                250: '2%',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            3: {
                                0: 'Level 3',
                                100: '1%',
                                250: '2%',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            4: {
                                0: 'Level 4',
                                100: '1%',
                                250: '2%',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            5: {
                                0: 'Level 5',
                                100: '',
                                250: '2%',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            6: {
                                0: 'Level 6',
                                100: '',
                                250: '',
                                500: '2%',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            7: {
                                0: 'Level 7',
                                100: '',
                                250: '',
                                500: '',
                                1000: '3%',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            8: {
                                0: 'Level 8',
                                100: '',
                                250: '',
                                500: '',
                                1000: '',
                                5000: '3%',
                                10000: '3%',
                                25000: '3%',
                            },
                            9: {
                                0: 'Level 9',
                                100: '',
                                250: '',
                                500: '',
                                1000: '',
                                5000: '',
                                10000: '3%',
                                25000: '3%',
                            },
                            10: {
                                0: 'Level 10',
                                100: '',
                                250: '',
                                500: '',
                                1000: '',
                                5000: '',
                                10000: '',
                                25000: '3%',
                            },
                        }
                    },
                    1: {
                        tableHeaders: {
                            0:  'level / no. of frontliners',
                            1: '100 FND own pack',
                            2: '5<br>frontliners',
                            3: '8<br>frontliners',
                            4: '10 frontliners',
                            5: '15 frontliners',
                            6: '20 frontliners',
                            7: '30 frontliners'
                        },
                        tableRows: {
                            1: {
                                0: 'Level 1',
                                1: '1%',
                                2: '2%',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            2: {
                                0: 'Level 2',
                                1: '1%',
                                2: '2%',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            3: {
                                0: 'Level 3',
                                1: '1%',
                                2: '2%',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            4: {
                                0: 'Level 4',
                                1: '1%',
                                2: '2%',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%',
                            },
                            5: {
                                0: 'Level 5',
                                1: '',
                                2: '2%',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            6: {
                                0: 'Level 6',
                                1: '',
                                2: '',
                                3: '2%',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            7: {
                                0: 'Level 7',
                                1: '',
                                2: '',
                                3: '',
                                4: '3%',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            8: {
                                0: 'Level 8',
                                1: '',
                                2: '',
                                3: '',
                                4: '',
                                5: '3%',
                                6: '3%',
                                7: '3%'
                            },
                            9: {
                                0: 'Level 9',
                                1: '',
                                2: '',
                                3: '',
                                4: '',
                                5: '',
                                6: '3%',
                                7: '3%',
                            },
                            10: {
                                0: 'Level 10',
                                1: '',
                                2: '',
                                3: '',
                                4: '',
                                5: '',
                                6: '',
                                7: '3%'
                            },
                        }
                    }
                },
                packets: {
                    0: '0',
                    100: 'FND 100',
                    250: 'FND 250',
                    500: 'FND 500',
                    1000: 'FND 1000',
                    5000: 'FND 5000',
                    10000: 'FND 10000',
                    25000: 'FND 25000'
                },
                loader: false,
            }
        },
        computed: {
            startPacket () {
                // Need to be increased by 1 for second table
                return this.HasUnilevelBonusFromFrontliners() ? (this.$store.getters.user.frontliners_unilevel_group + 1).toString() : this.$store.getters.user.position
            }
        },
        methods: {
            GetTableHeader() {
                return this.tableData[this.HasUnilevelBonusFromFrontliners()].tableHeaders;
            },
            GetTableRows() {
                return this.tableData[this.HasUnilevelBonusFromFrontliners()].tableRows;
            },
            HasUnilevelBonusFromFrontliners() {
                return this.$store.getters.user.has_unilevel_bonus_from_frontliners ? 1 : 0;
            },
            buyPacket (index) {
                this.packet.create(index)
                this.$store.commit('modals', {
                    modal: 'buyPacket',
                    data: {
                        visible: true,
                        message: 'Are you sure you want to buy this package?',
                        packet: this.packet
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .dashboard-header{
        margin: 0;

        h2{
            font-weight: normal;
            margin: 0 0 30px 0;
        }
    }

    .small-header-font {
        font-size: 11px;
    }

    a.buy-button{
        font-weight: bold;
        color: $white !important;
        background-color: $op;
        padding: 8px 15px;

        &.button--progress{
            color: rgba(0, 0, 0, 0) !important;
        }
        &.disabled {
            opacity: 0.3;
            cursor: default;
            pointer-events: none;
        }
    }

    .mb80{
        margin-bottom: 80px;
    }


</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/start-packet/StartPacketTable.vue